import Vue from "vue";
import Wrapper from "./Wrapper.vue";
import VueRouter from "vue-router";
import Axios from "axios";
import VueAxios from "vue-axios";

import App from "@/TodayApp";
import Login from "@/components/Login";

Vue.config.productionTip = false;

const routes = [{
    path: "/login",
    component: Login,
    name: "login"
  },
  {
    path: "/app",
    component: App,
    name: "TodayApp",
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "*",
    redirect: "/app"
  }
];

const router = new VueRouter({
  routes
});

Vue.use(VueRouter);
Vue.use(VueAxios, Axios);

new Vue({
  router,
  render: h => h(Wrapper)
}).$mount("#app");
